import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/ModalActions';
import { detectIOS, detectAndroid } from '../../../util/detectBrowser';

const MobileWebModal = ({ closeModal }) => (
  <div id="mobile-web-modal" className="text-center">
    <div className="modal-header margin-top">
      <img className="margin-bottom" alt="zola laptop" src="/images/dashboard/mobile_web@1x.png" />
      <h3 className="modal-title margin-top">Thanks for Stopping By!</h3>
    </div>
    <div className="modal-body text-center">
      <div>
        <p>Doesn&apos;t this look like fun? It&apos;ll look and work even better on your computer or on our app.</p>
      </div>
      <div className="margin-top">
        {detectIOS() &&
          <a href="https://itunes.apple.com/us/app/zola-weddings/id1224719355?ls=1&amp;mt=8" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-wide">Download the app</a>
        }
        {detectAndroid() &&
          <a href="https://play.google.com/store/apps/details?id=com.zola.android.wedding&hl=en" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-wide">Download the app</a>
        }
      </div>
      <div className="margin-top">
        <a role="button" className="text-button" onClick={closeModal}>I&apos;ll take my chances</a>
      </div>
    </div>
  </div>
);

MobileWebModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal())
});


export default connect(
  null,
  mapDispatchToProps
)(MobileWebModal);



/** WEBPACK FOOTER **
 ** ./src/components/manage/common/MobileWebModal.jsx
 **/